import { render, staticRenderFns } from "./VInventoryAttributeModal.vue?vue&type=template&id=bec55618"
import script from "./VInventoryAttributeModal.vue?vue&type=script&lang=js"
export * from "./VInventoryAttributeModal.vue?vue&type=script&lang=js"
import style0 from "./VInventoryAttributeModal.vue?vue&type=style&index=0&id=bec55618&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports